import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CourseService } from '@/services';
import type { Course } from '@/types';

export function useUpdateTimerRemaining() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      courseId,
      timerRemaining,
    }: {
      courseId: string;
      timerRemaining: number;
    }) => {
      CourseService.updateTimerRemaining(courseId, timerRemaining);
      return { courseId, timerRemaining };
    },
    onSuccess: ({ courseId, timerRemaining }) =>
      queryClient.setQueryData(['courses', courseId], (state: Course) => ({
        ...state,
        timerRemaining,
      })),
  });
}
